var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIspconfigLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 67.95 512 376.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#cc141b",
    d: "M18.42 79.38c9.15-7.3 20.78-11.88 32.59-11.39 137.66.02 275.33.02 412.99 0 10.79.28 21.19 4.74 29.57 11.41 10.51 8.23 17.09 20.99 18.43 34.21v209.63c-1.14 12.64-6.97 24.85-16.47 33.32-9.09 8.29-21.28 13.02-33.58 13.15-13.98.11-27.96.01-41.94.04-.02-16.66-.02-33.33 0-50 13.43-.11 26.88.2 40.31-.15-.18-67.28-.01-134.56-.08-201.84-136.75-.02-273.49-.01-410.23 0-.01 67.33-.02 134.66 0 201.99 98.01-.01 196.01 0 294.01 0 19.71.01 38.66 12.73 46.04 31.02 5.17 11.39 3.75 24.13 3.94 36.26.17 8.1-.16 16.41-3.15 24.04-6.57 18.62-25.1 32.33-44.86 32.93H175.03c-7.09-.09-14.33.55-21.24-1.47-16.57-4.19-30.5-17.32-35.5-33.69-3.11-9.14-2.17-18.88-2.27-28.35 17.08.02 34.15-.02 51.23.02.01 4.32 0 8.65 0 12.97 58.66.03 117.33.02 175.99.01.01-8.08.01-16.15 0-24.23-92.08-.01-184.16 0-276.24-.01-8.82-.22-17.73.67-26.45-1-14.56-3.1-27.8-12.59-34.82-25.8-3.16-5.9-5-12.43-5.73-19.06V113.66c1.29-13.26 7.91-26.02 18.42-34.28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8d9499",
    d: "M115.76 257.01c17.33-.02 34.66-.02 51.99.01 0 17.24.02 34.48 0 51.72-17.32.03-34.63 0-51.95.02-.12-17.25-.03-34.5-.04-51.75"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIspconfigLogo);
export default __webpack_public_path__ + "static/media/ispconfig-logo.6e18ffbcd75cfc93e00b10eb6c262891.svg";
export { ForwardRef as ReactComponent };